'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_Course(index, recipe, servings) {
  this.hJ = 0;
  this.ij = null;
  this.ri = 0;
  this.hJ = index;
  this.ij = recipe;
  this.ri = servings;
}
export { $c_Lmealorama_Course as $c_Lmealorama_Course };
$p = $c_Lmealorama_Course.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Course;
/** @constructor */
function $h_Lmealorama_Course() {
}
export { $h_Lmealorama_Course as $h_Lmealorama_Course };
$h_Lmealorama_Course.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 2024262715);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.hJ);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.ij));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.ri);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 3);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_Course)) {
    if (((this.hJ === x$0.hJ) && (this.ri === x$0.ri))) {
      var x = this.ij;
      var x$2 = x$0.ij;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 3;
});
$p.r = (function() {
  return "Course";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.hJ;
      break;
    }
    case 1: {
      return this.ij;
      break;
    }
    case 2: {
      return this.ri;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_Course(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jr)));
}
export { $isArrayOf_Lmealorama_Course as $isArrayOf_Lmealorama_Course };
var $d_Lmealorama_Course = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Course, "mealorama.Course", ({
  jr: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_Course as $d_Lmealorama_Course };
//# sourceMappingURL=mealorama.-Course.js.map
